var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRaliI(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 65,
    viewBox: "0 0 13 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6292 2.51577C10.7242 1.3469 9.43601 0.500473 7.95296 0.181384C7.93975 0.181384 7.92654 0.174667 7.91332 0.171308C7.83736 0.154514 7.75808 0.147796 7.6788 0.134361C7.33859 0.0772608 6.98848 0.0403137 6.63175 0.0403137C3.11735 0.0403137 0.266846 2.93898 0.266846 6.51277V58.457C0.266846 62.0308 3.11735 64.9295 6.63175 64.9295C10.1462 64.9295 12.9967 62.0308 12.9967 58.457V6.61018C12.9967 6.57659 13 6.54636 13 6.51613C13 5.00466 12.4847 3.61746 11.6292 2.51577ZM6.63175 2.33439C8.89762 2.33439 10.744 4.20862 10.744 6.51613C10.744 8.82364 8.90092 10.6979 6.63175 10.6979C4.36259 10.6979 2.5195 8.82364 2.5195 6.51613C2.5195 4.20862 4.36259 2.33439 6.63175 2.33439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRaliI);
export default __webpack_public_path__ + "static/media/logo-rali-i.07bc0163832a855e0c7b89e5f5c6489d.svg";
export { ForwardRef as ReactComponent };